import { useEffect } from "react";
import { useEvents } from "../calendar/useEvents";
import { useSettings } from "../settings/useSettings";
import { computeCandidateFireTimes, tickNotifications } from "./scheduler";

export function useNotificationScheduler() {
  const events = useEvents();
  const [settings] = useSettings();

  useEffect(() => {
    // small delay to avoid firing on cold-start jitter
    const t0 = window.setTimeout(() => tickNotifications(events, settings, 90_000), 1200);

    const id = window.setInterval(() => {
      tickNotifications(events, settings, 90_000);
    }, 60_000);

    const timeouts: number[] = [];
    const plan = () => {
      while (timeouts.length) window.clearTimeout(timeouts.pop());
      const times = computeCandidateFireTimes(events, settings, 12 * 60 * 60_000);

      const now = Date.now();
      for (const ts of times) {
        const delay = ts - now;
        if (delay < 0) continue;

        const tid = window.setTimeout(() => {
          tickNotifications(events, settings, 120_000);
        }, Math.min(delay + 250, 12 * 60 * 60_000));

        timeouts.push(tid);
      }
    };

    plan();

    const onVis = () => {
      if (document.visibilityState === "visible") {
        tickNotifications(events, settings, 180_000);
        plan();
      }
    };
    const onOnline = () => plan();

    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("online", onOnline);

    return () => {
      window.clearTimeout(t0);
      window.clearInterval(id);
      while (timeouts.length) window.clearTimeout(timeouts.pop());
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("online", onOnline);
    };
  }, [events, settings]);
}
